import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=522385d4&scoped=true&"
import script from "./Buy.vue?vue&type=script&lang=ts&"
export * from "./Buy.vue?vue&type=script&lang=ts&"
import style0 from "./Buy.vue?vue&type=style&index=0&id=522385d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522385d4",
  null
  
)

component.options.__file = "Buy.vue"
export default component.exports